import React, { Component } from "react";
import { Tabs } from "antd";
import Container from "../../../../../components/Container";
import styles from "./index.less";
import ReportStatistics from "./ReportStatistics/index";
import FileSummary from "./FileSummary/index";

const { TabPane } = Tabs;

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nowTab: '1'
    };
  }

  // tab切换的回调
  handleTabChange = value => {
    this.setState({
      nowTab: value
    });
  };

  render() {
    const { nowTab } = this.state;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Tabs onChange={this.handleTabChange} type="card">
            <TabPane tab="填报统计" key="1">
              {nowTab === '1' && <ReportStatistics tab={1} />}
            </TabPane>
            <TabPane tab="评估统计" key="2">
              {nowTab === '2' && <ReportStatistics tab={2} />}
            </TabPane>
            <TabPane tab="文件汇总" key="3">
              {nowTab === '3' && <FileSummary tab={3} />}
            </TabPane>
          </Tabs>
        </div>
      </Container>
    );
  }
}

export default Statistics;
